import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';





class Dashboard extends Component {

    render() {
        return (
            <Fragment>
                <Container className="mt-5 pt-5">

                    <Row>
                        <Col md={12}>
                            <h2>Welcome to Your Dashboard</h2>
                            <hr />
                        </Col>
                    </Row>

                    <Row>

                        <Col md={4}>
                            <Card className="shadow-sm mb-3">
                                <Card.Body>
                                    <h5>My Profile</h5>
                                    <p>Manage your account information.</p>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4}>
                            <Card className="shadow-sm mb-3">
                                <Card.Body>
                                    <h5>Notifications</h5>
                                    <p>View your latest notifications.</p>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4}>
                            <Card className="shadow-sm mb-3">
                                <Card.Body>
                                    <h5>Settings</h5>
                                    <p>Manage your preferences.</p>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>

                </Container>
            </Fragment>
        );
    }
}

export default Dashboard;